module.exports = __webpack_public_path__ + "static/media/Star.847d52fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/SmallTimeline/assets/Star.svg
// module id = 186
// module chunks = 0